module.exports = __webpack_public_path__ + "img/dignity-health_2.de8d87d2.jpg";